__turbopack_context__.v({
  "backdrop": "bMNI0a_backdrop",
  "backdropMotion": "bMNI0a_backdropMotion",
  "container": "bMNI0a_container",
  "content": "bMNI0a_content",
  "horizontal": "bMNI0a_horizontal",
  "large": "bMNI0a_large",
  "medium": "bMNI0a_medium",
  "placementBottom": "bMNI0a_placementBottom",
  "placementLeft": "bMNI0a_placementLeft",
  "placementRight": "bMNI0a_placementRight",
  "placementTop": "bMNI0a_placementTop",
  "small": "bMNI0a_small",
  "vertical": "bMNI0a_vertical",
  "wrapper": "bMNI0a_wrapper",
});
